/* Library */
import React, { Component } from 'react';
import { Link } from 'react-router';
// import { browserHistory } from 'react-router';

// components
import MiniNotifications from './components/MiniNotifications';
import ApplyCSS from '../ApplyCSS';
// Utils
import commonUtil from './../../utils/commonUtil';
// constants
const pageName = 'notifications';
const applicationRoutes = commonUtil.getApplicationRoutes();

class Notifications extends Component {
  // constructor(props) {
  //   super(props);
  //   // this.eventId = this.props.eventId;
  //   // this.profileId = this.props.profileId;
  // }

  render() {
    const { notifications, defaultImageNotifications } = this.props;
    const channel = commonUtil.getChannel();
    const showExtraLink =
      notifications &&
      notifications.notifications &&
      notifications.notifications.length >= 6 &&
      channel === 'web';
    let showAll = false;
    if (
      notifications &&
      notifications.notifications &&
      ((notifications.notifications.length <= 6 && channel === 'web') ||
        channel === 'wap')
    ) {
      showAll = true;
    }
    // ||    !(notifications && notifications.status && notifications.status.status === 'failure');
    return (
      <React.Fragment>
        <div
          id='Notifications-modal-overlay'
          className='notifications_modal_overlay'
        >
          <div className='modal-content-event'>
            <div className='evnt-modal-header'>
              <h4 className='modal-title'>Notificaciones</h4>
              <button
                className='close-button'
                onClick={this.props.openNotificationBar}
                aria-label='Cerrar modal'
              >
                <img
                  src={commonUtil.getAssetURL() + '/images/close.svg'}
                  alt=''
                  className='icon_vozcliente'
                />
              </button>
            </div>
            <div
              className='evnt_modal_body'
              onClick={(e) => e.stopPropagation()}
            >
              <div className={`product-container`}>
                <div className={`data-container`}>
                  <ApplyCSS pageName={pageName} />
                  <div className='listNotification hover-icon'>
                    {(notifications &&
                      notifications.notifications &&
                      notifications.notifications.length > 0) ||
                    (notifications && notifications.length > 0) ? (
                      notifications.notifications.map((data, index) => {
                        // if (!showAll && index > 5) {
                        //   return null;
                        // }
                        return (
                          <MiniNotifications
                            data={data}
                            eventId={this.props.eventId}
                            profileId={this.props.profileId}
                            defaultImageNotifications={
                              defaultImageNotifications
                            }
                          />
                        );
                      })
                    ) : (
                      <div className='information'>
                        <div className='col-md-12 text-center allNotifications'>
                          No existen notificaciones
                        </div>
                      </div>
                    )}

                    {/* {showExtraLink ?
                      <li className="information last-child">
                        <div className="col-md-12 text-center allNotifications">
                          <Link to={commonUtil.getRouteByParameter(applicationRoutes.notificationDetails, { eventID: this.props.eventId, profileId: this.props.profileId })} title="Ver todas las notificaciones" >
                            <a> Ver todas las notificaciones <i className="icon-flecha_lightsvg_derecha" /></a>
                          </Link>
                        </div>
                      </li>
                      :
                      null
                    } */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Notifications;
